import React from 'react';

import User from '../../../Api/Models/User';
import { formatBirthdayDate, formatDateStringWithTimezone as formatDateTz } from '../../../utils/formatters';
import ProtectedLink from '../../elements/ProtectedLink';
import BooleanIcon from '../../elements/booleanIcon';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';

import { PERMISSION } from 'crm/helpers/Permissions';

function UserDetails({ user }: { readonly user: User }) {
    return (
        <Card title="User details">
            <TableDetailsBody>
                <Row label="ID">{user.id}</Row>
                {User.isKycExposed() && <Row label="CPF">{user.cpf}</Row>}
                <Row label="Token">{user.token}</Row>
                <Row label="Name">{user.name}</Row>
                <Row label="Last name">{user.last_name}</Row>
                <Row label="Email">{user.email}</Row>
                <Row label="Gender">{user.gender}</Row>
                <Row label="Birthday">{formatBirthdayDate(user.birthday)}</Row>
                <Row label="Email confirmed">
                    <BooleanIcon value={!!user.is_confirmed} />
                </Row>
                <Row label="Phone confirmed">
                    <BooleanIcon value={user.phone_confirmed} />
                </Row>
                <Row label="KYC confirmed">
                    <BooleanIcon value={user.is_kyc_confirmed} />
                </Row>
                <Row label="Timezone">{user.timezone}</Row>
                <Row label="Address">{user.address}</Row>
                <Row label="Address 2">{user.address2}</Row>
                <Row label="City">{user.city}</Row>
                <Row label="Country">{user.country}</Row>
                <Row label="State">{user.state}</Row>
                <Row label="Postal code">{user.postal_code}</Row>
                <Row label="Last IP">{user.last_ip}</Row>
                <Row label="Last Country">{user.last_country}</Row>
                <Row label="Registration IP">{user.registration_ip}</Row>
                <Row label="Registration Country">{user.registration_country}</Row>
                <Row label="FTD">{formatDateTz(user.first_time_deposit_date)}</Row>
                <Row label="FTP">{formatDateTz(user.first_time_purchase_date)}</Row>
                <Row label="STD">{formatDateTz(user.second_time_deposit_date)}</Row>
                <Row label="STP">{formatDateTz(user.second_time_purchase_date)}</Row>
                <Row label="Created">{formatDateTz(user.created_at)}</Row>
                {user.deleted_at && <Row label="Deleted">{formatDateTz(user.deleted_at)}</Row>}
                <Row label="Reseller">
                    <BooleanIcon value={user.is_reseller} />
                </Row>
                <Row label="Affiliate" showIf={user.affiliate_id > 0}>
                    <ProtectedLink
                        url={`/affiliates/${user.affiliate_id}`}
                        permissions={[PERMISSION.VIEW_AFFILIATE]}
                        value={user.affiliate_name}
                    />
                </Row>
                <Row label="Did apply for reseller">
                    <BooleanIcon value={user.reseller_wants_to_become} />
                </Row>
                <Row label="Reseller revenue">{user.reseller_percent_revenue_formatted}</Row>
                <Row label="Reseller debit">{user.reseller_debit_formatted}</Row>
                <Row label="Phone">{user.phone}</Row>
                <Row label="Balance">{user.balance_formatted} </Row>
                <Row label="Deposit sum">{user.deposit_sum}</Row>
                <Row label="Purchase sum">{user.purchase_sum}</Row>
                <Row label="Withdrawal sum">{user.withdrawal_sum}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default UserDetails;
